module.exports = __webpack_public_path__ + "img/map_Z5.3.A.05.8a642cd9.svg";